import { message as toaster } from 'antd'

// const heading = "Kanakku";
// const toastPosition = "top-center";

const infoToast = (message) => {
  toaster.info({ content: message, className: 'toaster', duration: 4 })
}

const successToast = (message) => {
  toaster.success({ content: message, className: 'toaster', duration: 4 })
}

const errorToast = (message) => {
  toaster.error({ content: message, className: 'toaster', duration: 4 })
}

const fielderrorToast = (message) => {
  toaster.error({ content: message, className: 'toaster', duration: 4 })
}

const customerrorToast = (message) => {
  toaster.error({ content: message, className: 'toaster', duration: 4 })
}

const warningToast = (message) => {
  toaster.warn({ content: message, className: 'toaster', duration: 4 })
}

const loadingToast = () => {
  toaster.loading('Loading Content', {}).then(() => {})
}

export { infoToast, successToast, errorToast, warningToast, loadingToast, customerrorToast, fielderrorToast }
